module.exports = __webpack_public_path__ + "fa-brands-400.0938cd3c86ec4da5c548.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/webfonts/fa-brands-400.woff2
// module id = ../../../../../src/assets/fonts/webfonts/fa-brands-400.woff2
// module chunks = styles